import { Spinner, usePageNavigation } from '@shared/components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../hooks/useProfile';
import { ProfileView } from '../display/ProfileView';

export const Main = () => {
  const { t } = useTranslation('profileModule');
  const { isLoading } = useProfile();

  const breadcrumbs = useMemo(() => [{ label: t('pageTitle') }], [t]);

  usePageNavigation({ breadcrumbs });

  if (isLoading) {
    return (
      <div className="flex justify-center py-16" data-testid="profile-loading">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <ProfileView />
    </div>
  );
};
